import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// NOTE: React StrictMode is temporarily disabled to support react-beautiful-dnd
// Once we upgrade to a version of react-beautiful-dnd compatible with React 19,
// we can re-enable StrictMode
root.render(<App />);

reportWebVitals();
